<template>
    <div class="platformContainer">
        <div class="content" v-if="platformData" :style="{'min-height': contData.title ? '575px':'400px'}">
            <div class="platformItemBox">
                <div class="platformTitle" v-if="platformData.length > 1">
                    <div :class="{title:true, act: index == platState}" @click="checkHandle('platState', index)" v-for="(item, index) in platformData" :key="index">
                        <span class="pfIcon" v-show="index != platState"><img v-if="item.icon && item.icon.length > 2"  :src="item.icon[1].url" alt="" width="20px"></span>
                        <span class="pfIcon" v-show="index == platState"><img v-if="item.icon && item.icon.length > 2"  :src="item.icon[2].url" alt="" width="20px"></span>
                        {{item.title}}
                    </div>
                </div>
                <div class="labelList" v-show="labelData && contData.title">
                    <div :class="{labCont: true, act: index == labState}" @mouseover="checkHandle('labState', index)" v-for="(item, index) in labelData" :key="index">
                        <div class="icon"><img v-if="item.icon" :src="item.icon[0].url" width="47" alt=""></div>
                        <div class="name">{{item.title}}</div>
                    </div>
                </div>
                <div class="content" v-show="contData" :style="{'min-height': contData.title ? '575px':'400px'}">
                    <div class="image" :key="keyInt" v-if="contData.title"><img v-if="contData.file" :src="contData.file[0].url" width="650" alt=""></div>
                    <div class="image" :key="keyInt" v-else><img v-if="contData.file" :src="contData.file[0].url" width="100%" alt=""></div>
                    <div class="info" :key="keyInt" v-if="contData.title">
                        <div class="title">{{contData.title}}</div>
                        <div class="subTit">{{contData.url}}</div>
                        <div class="desc">{{contData.subTitle}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        platformData:null
    },
    data(){
        return {
            platState: 0,
            labState: 0,
            labelData:null,
            contData:null,
            keyInt: 0,
        }
    },
    watch:{
        platformData:{
            handler(value){
                if (value){
                    this.initData(value)
                }
            }
        }
    },
    mounted(){
        if(this.platformData){
            this.initData(this.platformData)
        }
    },
    methods:{
        checkHandle(key, index){
            if(this[key] !== index){
                if(key == 'platState') {
                    this.labState = 0
                }
                this[key] = index
                this.keyInt++
                this.initData(this.platformData)
            }
        },
        initData(initData){
            this.labelData = initData[this.platState].LableTree
            this.contData = this.labelData[this.labState].content[0]
        }
    }
}
</script>
<style scoped lang="scss">
  .platformContainer{
      max-width: 1180px;
      margin: 0 auto;
        .content{
            position: relative;
            min-height: 575px;
            .platformItemBox{
                text-align: left;
                .platformTitle{
                    position: absolute;
                    left: -100px;
                    top: 40%;
                    display: inline-block;
                    padding-right: 10px;
                    margin-bottom: 40px;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;
                    cursor: pointer;
                    border-left: solid 2px #cccccc;
                    z-index: 99;
                    background: transparent;
                    .pfIcon{
                        img{
                            position: relative;
                            top: 4px;
                        }
                    }
                    .title{
                        position: relative;
                        left: -2px;
                        padding-left: 10px;
                        margin-bottom: 20px;
                        border-left: solid 2px #cccccc;
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                    .act{
                        color: #07adff;
                        border-left: solid 2px #cccccc;
                        border-color:#07adff;
                    }
                }
            }
            .labelList{
                display: flex;
                justify-content: center;
                margin-bottom: 60px;
                border-bottom: solid 1px #ededed;
                .labCont{
                    flex: 1;
                    cursor: pointer;
                    max-width: 147px;
                    text-align: center;
                    
                    .name{
                        line-height: 50px;
                        font-size: 14px;
                    }
                }
                .act{
                    position: relative;
                    &::before{
                        content: '';
                        display: inline-block;
                        animation:linelang 500ms forwards;
                        height: 1px;
                        width: 129px;
                        position: absolute;
                        bottom:0px;
                        left: 50%;
                        background: #07adff;
                        transform: translateX(-50%);
                    }
                }
            }
            .content{
                display: flex;
                .image{
                    flex: 1;
                    position: relative;
                    opacity:0;
                    animation: easeShow 750ms ease-in-out forwards;
                }
                .info{
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    justify-content: center;
                    color: #19232B;
                    padding-left: 100px;
                    .title{
                        opacity: 0;
                        font-size: 60px;
                        line-height: 120px;
                        position: relative;
                        top: 10px;
                        font-weight: bold !important;
                        animation: fontFloat 550ms ease-in-out forwards;
                    }
                    .subTit{
                        opacity: 0;
                        font-size: 24px;
                        line-height: 33px;
                        position: relative;
                        font-weight: 500;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        top: 10px;
                        animation: fontFloat 550ms ease-in-out 200ms forwards;
                    }
                    .desc{
                        opacity: 0;
                        font-size: 16px;
                        line-height: 32px;
                        position: relative;
                        top: 10px;
                        animation: fontFloat 550ms ease-in-out 300ms forwards;
                    }
                }
            }
        }
        @keyframes fontFloat {
            0%{
                top: 10px;
                opacity: 0;
            }
            100%{
                top:-70px;
                opacity: 1;
            }
        }
        @keyframes easeShow {
            0%{
                top: 30px;
                opacity: 0;
            }
            100%{
                top: 0px;
                opacity:1;
            }
        }
        @keyframes linelang {
            from {width:0px;}
            to {width:129px;}
        }  
      
}
    @media (max-width: 1400px) {
        .platformTitle{
            left: -50px !important;
        }
    } 
    @media (max-width: 1240px) {
        .platformTitle{
            left: 0px !important;
        }
    } 
</style>